import { FuelGridItem } from '@frete.com/fuel-react';
import { BOTTOM_MENU_HEIGHT, LARGE_TOP_BAR_HEIGHT, SMALL_TOP_BAR_HEIGHT } from 'constants/styled.contants';
import { TTruckerActiveItem } from 'context/reducers/truckers.type';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100vw;
  height: calc(100vh - ${SMALL_TOP_BAR_HEIGHT});
  overflow: hidden;

  > .grid-container.sc-fuel-grid-container-h {
    height: inherit;
    margin: 0 0 0 ${({ theme }) => theme.spacing.km12};

    > fuel-grid-item {
      overflow: hidden;
      height: inherit;
    }

    > :first-child {
      margin-right: -${({ theme }) => theme.spacing.km6};
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.lg.maxWidth}) {
    height: calc(100vh - ${LARGE_TOP_BAR_HEIGHT});
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    height: calc(100vh - ${SMALL_TOP_BAR_HEIGHT} - ${BOTTOM_MENU_HEIGHT});
    > .grid-container.sc-fuel-grid-container-h {
      margin: 0;

      > :first-child {
        margin: unset;
      }
    }
  }

  @media (max-width: 576px) {
    height: calc(100vh - ${LARGE_TOP_BAR_HEIGHT} - ${BOTTOM_MENU_HEIGHT});
  }
`;

export const DriverProfileWrapper = styled.div`
  height: inherit;

  > :first-child {
    height: 100%;
    padding-bottom: ${({ theme }) => theme.spacing.km10};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    ${({ theme }) =>
      css`
        border-left: ${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.default};
      `}
  }
`;

export const FuelGridItemProfile = styled(FuelGridItem)<{ activeDriver: TTruckerActiveItem }>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    min-width: 532px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    background-color: ${({ theme }) => theme.color.background.neutral.default};
    transform-origin: right;
    transition-delay: 0.1s;
    transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
    transform: scaleX(0.6);
    opacity: 0;
    width: 100%;

    ${({ activeDriver }) =>
      activeDriver &&
      css`
        &&& {
          position: fixed;
          z-index: 12;
          transform: scaleX(1);
          opacity: 1;
          left: 0;
        }
      `};
  }
`;
